import { CategoryDetails } from "./category-details";

export class DrrDetails {
    date: Date;
    categoryDetails: CategoryDetails[]
    constructor(date: Date, categoryDetails: CategoryDetails[]) {
        this.date = date;
        this.categoryDetails = categoryDetails;
    }
}